import * as React from 'react'

type SidebarHomeIconProps = React.SVGProps<SVGSVGElement> & {
  active?: boolean
  size?: number | string
}

export const SidebarHomeIcon = React.forwardRef<SVGSVGElement, SidebarHomeIconProps>(
  ({ active = false, size = 24, className, ...props }, ref) => {
    const mainFill = active ? '#0B2B45' : '#FFFFFF'

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g transform="translate(1, 1) scale(1.7)">
          <path
            d="M10.7549 16.1504H15.6149V23.2554C15.6499 23.2754 15.6849 23.2904 15.7199 23.3054H22.0349V12.0704L17.4649 7.43542C13.6499 8.52542 10.8349 12.0054 10.7599 16.1504H10.7549Z"
            fill="#61C9DC"
          />
          <path
            d="M9.83992 16.2804V16.1054L9.84992 16.0804C9.95492 11.6954 12.8449 7.99042 16.8249 6.67542L12.7599 2.55542L3.41992 12.0254V23.3054H9.83992V16.3704C9.83992 16.3704 9.83992 16.3404 9.83992 16.3254C9.83992 16.3104 9.83992 16.2954 9.83992 16.2804Z"
            fill={mainFill}
          />
          <path
            d="M15.615 23.3055H15.72C15.685 23.2855 15.65 23.2755 15.615 23.2555V23.3055Z"
            fill={mainFill}
          />
        </g>
      </svg>
    )
  },
)

SidebarHomeIcon.displayName = 'SidebarHomeIcon'
